module.exports = __webpack_public_path__ + "img/header_home_mobile_v2.17f18ca6.png";